import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ArrowBackIosNewRounded, ArrowForwardIos } from "@mui/icons-material";
import {
    HiOutlineArrowNarrowDown,
} from "react-icons/hi";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import Banner1 from "assets/images/Parallax/SessionA/Fossil Management Fund (1).png";
import Banner2 from "assets/images/Parallax/SessionA/Fossil Management Fund (2).png";
import Banner3 from "assets/images/Parallax/SessionA/Fossil Management Fund (3).png";
import { Box, Fab, IconButton, Typography, Zoom, useMediaQuery, useScrollTrigger } from '@mui/material';
import { ParseHtml } from 'utilities/utilities';


const Banner = ({ bannerData, IsPreview, registerRef = null }) => {
    const sliderRef = useRef<any>(null);

    const [windowWidth, setWindowWidth] = useState(0)
    const [windowHeight, setWindowHeight] = useState(0)
    const waitBeforeShow = IsPreview ? 10 : 500;
    const [isShown, setIsShown] = useState(false);
    const [arrBanner, setarrBanner] = useState([])
    const [nActiveSlide, setnActiveSlide] = useState(1)
    const [nCount, setnCount] = useState(0)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, waitBeforeShow);
        return () => clearTimeout(timer);
    }, [waitBeforeShow]);

    useEffect(() => {

        if (bannerData.length === 0) {
            let arr = ["/dev", "/qas", "/Dev", "QAS"];
            let img1 = Banner1;
            let img2 = Banner2;
            let img3 = Banner3;
            arr.map(f => {
                let isBanner1 = Banner1.includes(f);
                let isBanner2 = Banner2.includes(f);
                let isBanner3 = Banner3.includes(f);

                if (isBanner1) {
                    img1 = f === "/Dev" ? img1.replace(f, "Dev") : img1.replace(f, "");
                }
                if (isBanner2) {
                    img2 = f === "/Dev" ? img2.replace(f, "Dev") : img2.replace(f, "");
                }
                if (isBanner3) {
                    img3 = f === "/Dev" ? img3.replace(f, "Dev") : img3.replace(f, "");
                }

            }
            )

            img1 = process.env.REACT_APP_FRONTEND_URL + img1;

            img2 = process.env.REACT_APP_FRONTEND_URL + img2;

            img3 = process.env.REACT_APP_FRONTEND_URL + img3;
            let objBannerDefault = [
                {
                    key: 1,
                    img: img1,
                    nAlign: null,
                    nvAlign: null,
                    IsTextOption: null,
                    IsLink: null,
                    nLinkTypeShowID: null,
                    sLink: null,
                    lstHeadlineOption: null
                },
                {
                    key: 2,
                    img: img2,
                    nAlign: null,
                    nvAlign: null,
                    IsTextOption: null,
                    IsLink: null,
                    nLinkTypeShowID: null,
                    sLink: null,
                    lstHeadlineOption: null
                },
                {
                    key: 3,
                    img: img3,
                    nAlign: null,
                    nvAlign: null,
                    IsTextOption: null,
                    IsLink: null,
                    nLinkTypeShowID: null,
                    sLink: null,
                    lstHeadlineOption: null
                }
            ]
            setarrBanner(objBannerDefault);
            setnCount(3);

        } else {
            setarrBanner(bannerData);
            setnCount(bannerData.length ?? 1);
            if (bannerData.sFileLink) {

                setarrBanner([bannerData]);
                setnCount(bannerData.length ?? 1);
            }

        }

    }, [bannerData]);

    useEffect(() => {
        window.addEventListener('resize', e => {
            setWindowWidth(window.innerWidth);
        });
    }, [window.innerWidth]);

    useEffect(() => {
        window.addEventListener('resize', e => {
            setWindowHeight(window.innerHeight);
        });
    }, [window.innerHeight]);



    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.slidePrev();

    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.slideNext();
    }, []);

    const vertical = (type, value) => {
        let result = "";
        let arrTop = [7, 8, 9];
        let arrMiddle = [8, 10, 11, 12, 14];
        let arrBottom = [13, 14, 15];
        let arrLeft = [9, 12, 15];
        let arrRight = [7, 10, 13];

        // nDataID	sNameTH
        // 7	บนขวา
        // 8	บนตรงกลาง
        // 9	บนซ้าย
        // 10	ตรงกลางขวา
        // 11	ตรงกลาง
        // 12	ตรงกลางซ้าย
        // 13	ล่างขวา
        // 14	ล่างตรงกลาง
        // 15	ล่างซ้าย
        if (type === "sAlign") {

            if (arrTop.includes(value)) {
                result = "start";
            } else if (arrBottom.includes(value)) {
                result = "end";

            } else {
                result = "center";

            }

        } else if (type === "vAlign") {
            if (arrLeft.includes(value)) {
                result = "start";
            }
            // else if (value === "center") {
            //     result = "center";
            // } 
            else if (arrRight.includes(value)) {
                result = "end";
            }
            else {
                result = "center";
            }

        }

        return result;
    }

    const openLinks = (URL, LinkTypeShow) => {
        ////LinkType 1ภายใน 2ภายนอก
        // nDataID	nDataTypeID
        // 16	4  new tab
        // 17	4  new windows
        // 18	4  self win
        let currentURL = URL;

        if (LinkTypeShow === 16) {
            window.open(currentURL, "_blank", 'noopener noreferrer');
        }
        else if (LinkTypeShow === 17) {
            // window.open(url, "", 'width=600,height=400,left=200,top=200');
            window.open(currentURL, "newWin", "width=" + windowWidth + ",height=" + windowHeight);
        }
        else {
            window.open(currentURL, "_self", 'noopener noreferrer');
        }

    }

    const onImageError = (e) => {   //DOM-based cross-site scripting

        e.target.src = Banner1;
    }
    const MediaMin767 = useMediaQuery('(min-width:767px)');
    return (
        <React.Fragment>
            {(isShown && arrBanner.length > 0) &&
                <div style={{ position: 'relative', maxHeight: '104vh' }}>
                    <Swiper
                        ref={sliderRef}
                        spaceBetween={0}
                        slidesPerView={1}
                        className="mySwiper"
                        effect={'fade'}
                        speed={2000}
                        loop={true}
                        rewind={true}
                        centeredSlides={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: true,
                        }}
                        onSwiper={(swiper) => {
                            sliderRef.current = swiper;
                        }}
                        modules={[Pagination, Autoplay, Navigation]}
                        onSlideChange={(swiperCore) => {
                            const {
                                realIndex,
                            } = swiperCore;
                            setnActiveSlide(realIndex + 1);
                        }}
                    >
                        {
                            arrBanner.map(item => {

                                let html2 = <></>;
                                let BoxHtml =
                                    <Box className="box-datatext-banner"
                                        sx={{
                                            justifyContent: vertical("sAlign", item.nAlign ?? 10),
                                            alignItems: vertical("vAlign", item.nvAlign ?? 10)
                                        }}>
                                        <Box className="box-datatext-banner"
                                            sx={{
                                                justifyContent: vertical("sAlign", item.nAlign ?? 10),
                                                alignItems: vertical("vAlign", item.nvAlign ?? 10),
                                                textAlign: "start",
                                                width: "fit-content",
                                                height: "fit-content",
                                            }}>
                                            {
                                                item.lstHeadlineOption && item.lstHeadlineOption.length !== 0 ?

                                                    item.lstHeadlineOption.filter((f) => f.sTextMode !== "D").map((itemSub, indexSub) => {
                                                        let sMinFont = "0.6em";
                                                        if (itemSub.sHeadlineSize === "2.5em") {
                                                            sMinFont = "1em";
                                                        } else if (itemSub.sHeadlineSize === "1.4em") {
                                                            sMinFont = "0.8em";
                                                        }
                                                        let BoxTextHtml = <Box key={itemSub.nID}
                                                            sx={{
                                                                // fontSize: `${itemSub.sHeadlineSize}`,
                                                                fontSize: `clamp(${sMinFont}, 2.5vw, ${itemSub.sHeadlineSize})`,
                                                                color: `${itemSub.sHeadlineColor}`,
                                                                marginBottom: !MediaMin767 ? "5px": "15px"
                                                            }}>
                                                            {ParseHtml(itemSub.sHeadline)}
                                                        </Box>
                                                        return (BoxTextHtml)
                                                    })
                                                    :
                                                    <></>
                                            }
                                        </Box>
                                    </Box>

                                ///sEventID 137=LinksUrl 138=LinksDownload
                                if (!IsPreview && item.IsLink) {
                                    if (item.IsTextOption) {
                                        html2 = <Box sx={{ cursor: "pointer", height: "100%", width: "100%" }}
                                            onClick={() => openLinks(item.sLink, item.nLinkTypeShowID)}>
                                            {BoxHtml}
                                        </Box>
                                    }
                                    else {
                                        html2 = <Box onClick={() => openLinks(item.sLink, item.nLinkTypeShowID)}
                                            sx={{
                                                cursor: "pointer",
                                                height: "100%",
                                                width: "100%"
                                            }}>
                                        </Box>
                                    }
                                }
                                else if (item.IsTextOption) {
                                    html2 = (BoxHtml)
                                }
                                // }

                                const ImageFile = ["jpg", "jpeg", "png", "gif"];
                                ////Banner Video หรือ Image
                                let img = IsPreview ? item.sFileLink : item.img;

                                img = img.startsWith('https') || img.startsWith('http') ? img : process.env.REACT_APP_API_URL + img;

                                let html1 = <SwiperSlide key={item.key}>
                                    <Box className="box-banner">
                                        <img src={img} onError={onImageError} alt='Banner' />
                                        <Box className="box-text-banner">
                                            {html2}
                                        </Box>
                                    </Box>
                                </SwiperSlide>
                                return (
                                    html1


                                )
                            })
                        }
                    </Swiper>
                    {!IsPreview &&
                        <div className='banner-btn-navigate'>
                            <IconButton aria-label="delete" size="medium" onClick={() => handleNext()}>
                                <ArrowForwardIos />
                            </IconButton>
                            <IconButton aria-label="delete" size="medium" onClick={() => handlePrev()}>
                                <ArrowBackIosNewRounded />
                            </IconButton>
                        </div>
                    }
                    <div className='banner-btn-pagination'>
                        <div className="pagination-container">
                            <Typography className='pagination-active'>
                                {nActiveSlide}
                            </Typography>
                            <div className="pagination-triangle" />
                            <Typography className='pagination-total'>
                                {nCount}
                            </Typography>
                        </div>

                    </div>
                    {!IsPreview &&
                        <ScrollToBottom registerRef={registerRef}>
                            <Fab
                                size="large"
                                sx={{
                                    flexDirection: "column",
                                    borderRadius: "16px",
                                    width: "35px",
                                    height: "70px",
                                    backgroundColor: "#fade8a",
                                    color: ""
                                }}
                            >
                                <HiOutlineArrowNarrowDown size="25" color='#3c3322' />
                            </Fab>
                            <Typography style={{ marginTop: '8px', marginLeft: '12px', textTransform: 'uppercase', color: 'white' }}>
                                {MediaMin767 && <>scroll<br />down</>}
                            </Typography>
                        </ScrollToBottom>
                    }
                </div>
            }
        </React.Fragment>
    )
}

export default Banner

const ScrollToBottom = (props) => {
    const { children, registerRef } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 500,
    });
    const handleClick = () => {
        if (registerRef) {
            const windowViewport = registerRef.current.getBoundingClientRect();
            window.scrollTo({
                top: windowViewport.top + window.scrollY + 5,
                behavior: 'smooth'
            });

        }
    };

    return (
        <Zoom in={!trigger}>

            <div
                onClick={handleClick}
                role="presentation"
                id="toButtom"
                className='banner-btn-presentation'
                // style={{
                //     zIndex: 1,
                //     display: "flex",
                //     height: "87.5px",
                //     position: 'absolute',
                //     bottom: '0',
                //     left: '49%'
                // }}
            >
                {children}
            </div>
        </Zoom>

    );
};